"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSearchSearchResult = void 0;
const openapi_1 = require("../openapi");
exports.OpenSearchSearchResult = (0, openapi_1.genericSchema)((type) => {
    let OpenSearchSearchResult_T = class OpenSearchSearchResult_T {
        count;
        searchAfter;
        items;
    };
    __decorate([
        (0, openapi_1.Schema)({ type: 'number', description: 'Total results' })
    ], OpenSearchSearchResult_T.prototype, "count", void 0);
    __decorate([
        (0, openapi_1.Optional)(),
        (0, openapi_1.Schema)({
            type: 'array',
            items: {
                oneOf: [{ type: 'number' }, { type: 'string' }],
            },
        })
    ], OpenSearchSearchResult_T.prototype, "searchAfter", void 0);
    __decorate([
        (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => type) })
    ], OpenSearchSearchResult_T.prototype, "items", void 0);
    OpenSearchSearchResult_T = __decorate([
        (0, openapi_1.ClassSchema)({ name: `OpenSearchResult-${type.name}` })
    ], OpenSearchSearchResult_T);
    return OpenSearchSearchResult_T;
});
